import styles from './support.module.scss';
import {Link} from 'react-router-dom';
import {Avatar} from '../../../components/avatar/avatar.tsx';
import {Size} from '../../../enums/size.ts';
import {__} from '../../../support/lang/translations.ts';
import {FlexRow} from '../../../components/utility/flex_row.tsx';
import {Alignment} from '../../../enums/alignment.ts';

interface OwnProps {
    src?: string;
    name?: string;
    to: string;
    whatsAppNumber?: string | null;
}

export function Support({src, name, to, whatsAppNumber}: OwnProps) {
    if (whatsAppNumber != null) {
        return (
            <Link to={`https://wa.me/${whatsAppNumber}`} target="_blank" className={styles.whatsapp}>
                <i className="fa-brands fa-whatsapp" />
            </Link>
        );
    }
    return (
        <Link to={to} className={styles.support} viewTransition={true}>
            <FlexRow alignment={Alignment.Start}>
                <Avatar src={src ?? ''} name={name ?? ''} size={Size.Small} />
                <span className={styles.support__title}>{__('dashboard.titles.support')}</span>
                <i className="fa-regular fa-comment" />
            </FlexRow>
        </Link>
    );
}
